export const POSTBOX_TAB = 'postbox';
export const LIABILITY_TAB = 'liability';
export const EDIT_TAB = 'edit';

export const CANCEL_TAB = 'close';
export const REPORT_PAYMENT_TAB = 'report payment';
export const CONTACT_FORM_TAB = 'contact form';
export const CREDIT_MEMO_TAB = 'credit memo';
export const ON_HOLD_TAB = 'on hold';
